<template>
  <form @submit.prevent="beginProcess()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Verify Changes/Additions to FileMaker
        </p>
      </header>
      <section class="modal-card-body">
        <transition name="fade" mode="out-in">
          <div v-if="submitting" key="submitting">
            <div v-for="(step, index) in submissionSteps" :key="index">
              <div v-if="step.status === 'waiting'" class="flex items-center">
                <d-icon icon="clock" class="mr-3" /> {{ step.title }}
              </div>
              <div v-else-if="step.status === 'error'" class="flex items-center">
                <d-icon icon="times" class="mr-3" /> {{ step.title }}
              </div>
              <div v-else class="flex items-center">
                <d-icon icon="check" class="mr-3" /> {{ step.title }}
              </div>
            </div>
            <div v-if="processingErrorMessage" class="pt-5 text-error">
              An error has occurred: {{ processingErrorMessage }}
            </div>
          </div>
          <div v-else key="waiting">
            <p class="mb-8">
              Please review the following information that will be submitted to FileMaker. Press the "Go Back" button to make further changes, or update the information in FileMaker after approval has finalized. Once you press "Continue", please stay on this page while the information process.
            </p>
            <div v-if="enoughDetailsToAddWWOrg" class="mb-5">
              <p class="text-xl font-bold mb-2">
                {{ wwOrg['Organization ID'] ? 'Update' : 'New' }} Organization
              </p>
              <p><strong>Name</strong>: {{ wwOrg['Organization Name'] }}</p>
              <p><strong>Email</strong>: {{ wwOrg['Organization Email Address'] }}</p>
              <p><strong>Phone</strong>: {{ wwOrg.Phone }}</p>
              <p><strong>Fax</strong>: {{ wwOrg['Phone Fax'] }}</p>
              <p><strong>Address 1</strong>: {{ wwOrg['Address Line1'] }}</p>
              <p><strong>Address 2</strong>: {{ wwOrg['Address Line2'] }}</p>
              <p><strong>City</strong>: {{ wwOrg['Address City'] }}</p>
              <p><strong>State</strong>: {{ wwOrg['Address State'] }}</p>
              <p><strong>Zip/Postal</strong>: {{ wwOrg['Address Zip'] }}</p>
              <p><strong>Country</strong>: {{ wwOrg['Address Country'] }}</p>
              <p><strong>Website URL</strong>: {{ wwOrg.WebsiteURL }}</p>
            </div>
            <div v-if="enoughDetailsToAddWWContact" class="mb-5">
              <p class="text-xl font-bold mb-2">
                {{ wwContact['Contact ID'] ? 'Update' : 'New' }} Contact
              </p>
              <p><strong>First Name</strong>: {{ wwContact['Name First Name'] }}</p>
              <p><strong>Last Name</strong>: {{ wwContact['Name Last Name'] }}</p>
              <p><strong>Member Type</strong>: {{ wwContact['Member Type'] }}</p>
              <p><strong>Job Title</strong>: {{ wwContact['Job Title'] }}</p>
              <p><strong>Email</strong>: {{ wwContact.Email }}</p>
              <p><strong>Phone</strong>: {{ wwContact.Phone }}</p>
              <p><strong>Phone Fax</strong>: {{ wwContact['Phone Fax'] }}</p>
              <p><strong>Is QCP Liaison?</strong>: {{ wwContact['QCP liaison'] === '1' ? 'Yes' : 'No' }}</p>
              <p><strong>Is Billing Contact?</strong>: {{ wwContact['Billing Contact'] === '1' ? 'Yes' : 'No' }}</p>
            </div>
            <div v-if="enoughDetailsToAddGCOrg" class="mb-5">
              <p class="text-xl font-bold mb-2">
                {{ gcOrg['Organization ID'] ? 'Update' : 'New' }} Organization
              </p>
              <p><strong>Name</strong>: {{ gcOrg['Organization Name'] }}</p>
              <p><strong>Email</strong>: {{ gcOrg['Organization Email Address'] }}</p>
              <p><strong>Phone</strong>: {{ gcOrg.Phone }}</p>
              <p><strong>Fax</strong>: {{ gcOrg['Phone Fax'] }}</p>
              <p><strong>Address 1</strong>: {{ gcOrg['Address Line1'] }}</p>
              <p><strong>Address 2</strong>: {{ gcOrg['Address Line2'] }}</p>
              <p><strong>City</strong>: {{ gcOrg['Address City'] }}</p>
              <p><strong>State</strong>: {{ gcOrg['Address State'] }}</p>
              <p><strong>Zip/Postal</strong>: {{ gcOrg['Address Zip'] }}</p>
              <p><strong>Country</strong>: {{ gcOrg['Address Country'] }}</p>
              <p><strong>Website URL</strong>: {{ gcOrg.WebsiteURL }}</p>
            </div>
            <div v-if="enoughDetailsToAddGCContact" class="mb-5">
              <p class="text-xl font-bold mb-2">
                {{ gcContact['Contact ID'] ? 'Update' : 'New' }} Contact
              </p>
              <p><strong>First Name</strong>: {{ gcContact['Name First Name'] }}</p>
              <p><strong>Last Name</strong>: {{ gcContact['Name Last Name'] }}</p>
              <p><strong>Member Type</strong>: {{ gcContact['Member Type'] }}</p>
              <p><strong>Job Title</strong>: {{ gcContact['Job Title'] }}</p>
              <p><strong>Email</strong>: {{ gcContact.Email }}</p>
              <p><strong>Phone</strong>: {{ gcContact.Phone }}</p>
              <p><strong>Phone Fax</strong>: {{ gcContact['Phone Fax'] }}</p>
              <p><strong>Is QCP Liaison?</strong>: {{ gcContact['QCP liaison'] === '1' ? 'Yes' : 'No' }}</p>
              <p><strong>Is Billing Contact?</strong>: {{ gcContact['Billing Contact'] === '1' ? 'Yes' : 'No' }}</p>
            </div>
            <div v-if="enoughDetailsToAddADOrg" class="mb-5">
              <p class="text-xl font-bold mb-2">
                {{ adOrg['Organization ID'] ? 'Update' : 'New' }} Organization
              </p>
              <p><strong>Name</strong>: {{ adOrg['Organization Name'] }}</p>
              <p><strong>Email</strong>: {{ adOrg['Organization Email Address'] }}</p>
              <p><strong>Phone</strong>: {{ adOrg.Phone }}</p>
              <p><strong>Fax</strong>: {{ adOrg['Phone Fax'] }}</p>
              <p><strong>Address 1</strong>: {{ adOrg['Address Line1'] }}</p>
              <p><strong>Address 2</strong>: {{ adOrg['Address Line2'] }}</p>
              <p><strong>City</strong>: {{ adOrg['Address City'] }}</p>
              <p><strong>State</strong>: {{ adOrg['Address State'] }}</p>
              <p><strong>Zip/Postal</strong>: {{ adOrg['Address Zip'] }}</p>
              <p><strong>Country</strong>: {{ adOrg['Address Country'] }}</p>
              <p><strong>Website URL</strong>: {{ adOrg.WebsiteURL }}</p>
            </div>
            <div v-if="enoughDetailsToAddADContact" class="mb-5">
              <p class="text-xl font-bold mb-2">
                {{ adContact['Contact ID'] ? 'Update' : 'New' }} Contact
              </p>
              <p><strong>First Name</strong>: {{ adContact['Name First Name'] }}</p>
              <p><strong>Last Name</strong>: {{ adContact['Name Last Name'] }}</p>
              <p><strong>Member Type</strong>: {{ adContact['Member Type'] }}</p>
              <p><strong>Job Title</strong>: {{ adContact['Job Title'] }}</p>
              <p><strong>Email</strong>: {{ adContact.Email }}</p>
              <p><strong>Phone</strong>: {{ adContact.Phone }}</p>
              <p><strong>Phone Fax</strong>: {{ adContact['Phone Fax'] }}</p>
              <p><strong>Is QCP Liaison?</strong>: {{ adContact['QCP liaison'] === '1' ? 'Yes' : 'No' }}</p>
              <p><strong>Is Billing Contact?</strong>: {{ adContact['Billing Contact'] === '1' ? 'Yes' : 'No' }}</p>
            </div>
            <div class="mb-5">
              <p class="text-xl font-bold mb-2">
                {{ project['QCP Project Number Calc'] ? 'Update' : 'New' }} Project
              </p>
              <p><strong>Name</strong>: {{ project['PR Name'] }}</p>
              <p><strong>City</strong>: {{ project['PR City'] }}</p>
              <p><strong>State</strong>: {{ project['PR St'] }}</p>
              <p><strong>Country</strong>: {{ project['PR Country'] }}</p>
              <p><strong>Zip/Postal</strong>: {{ project['PR Zip'] }}</p>
              <p><strong>Referenced Standard</strong>: {{ project['Referenced Standard'] }}</p>
              <p><strong>Type</strong>: {{ project['ProjectType'] }}</p>
              <p><strong>Status at Registration</strong>: {{ project['Project Phase at time of Registration'] }}</p>
              <p><strong>Date Next Contact</strong>: {{ project['Date Next Contact'] }}</p>
              <p><strong>QCP/Project Status</strong>: {{ project['PR Status'] }}</p>
              <p><strong>Project Bid Date</strong>: {{ project['Bid Date'] }}</p>
              <p><strong>Estimated Shop Drawing Date</strong>: {{ project['Date Specs Confirmed'] }}</p>
              <p><strong>Estimated Project Completion Date</strong>: {{ project['Estimated Completion Date of Project'] }}</p>
            </div>
          </div>
        </transition>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn v-if="!submitting || processingErrorMessage" flat color="gray-800" @click="$parent.close()">
          Go Back
        </d-btn>
        <d-btn v-if="!processingErrorMessage" type="submit" color="success" :loading="submitting">
          Continue
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  import { updateAdmin, sendApprovedEmail } from '@resources/scripts/services/api/projectRegistration.api';
  import filemakerService from '@resources/scripts/services/filemakerMapper.service';
  import projectRegistrationService from '@resources/scripts/services/projectRegistration.service';
  import { RequestStatus } from '@resources/scripts/models/enums';
  import { createContact, updateContact, queryFirstContact } from '@resources/scripts/services/api/filemakerContacts.api';
  import { createProject, updateProject } from '@resources/scripts/services/api/filemakerProjects.api';
  import { createOrg, queryFirstOrg, updateOrg } from '@resources/scripts/services/api/filemakerOrganizations.api';

  export default {
    props: {
      submissionId: Number,
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    data: () => ({
      wwOrg: {},
      wwContact: {},
      gcOrg: {},
      gcContact: {},
      adOrg: {},
      adContact: {},
      project: {},
      submitting: false,
      processingErrorMessage: '',
      newSubmissionDetails: {},
      submissionSteps: [
        {
          title: 'Submit Woodworker Organization',
          status: 'waiting',
        },
        {
          title: 'Submit Woodworker Contact',
          status: 'waiting',
        },
        {
          title: 'Submit General Contractor Organization',
          status: 'waiting',
        },
        {
          title: 'Submit General Contractor Contact',
          status: 'waiting',
        },
        {
          title: 'Submit Firm Organization',
          status: 'waiting',
        },
        {
          title: 'Submit Firm Contact',
          status: 'waiting',
        },
        {
          title: 'Submit Project',
          status: 'waiting',
        },
      ],
    }),

    computed: {
      enoughDetailsToAddWWContact() {
        return this.wwContact['Name First Name'] || this.wwContact['Name Last Name'] || this.wwContact.Email;
      },

      enoughDetailsToAddGCContact() {
        return this.gcContact['Name First Name'] || this.gcContact['Name Last Name'] || this.gcContact.Email;
      },

      enoughDetailsToAddADContact() {
        return this.adContact['Name First Name'] || this.adContact['Name Last Name'] || this.adContact.Email;
      },

      enoughDetailsToAddWWOrg() {
        return this.wwOrg['Organization Name'] || this.wwOrg['Organization Email Address'];
      },

      enoughDetailsToAddGCOrg() {
        return this.gcOrg['Organization Name'] || this.gcOrg['Organization Email Address'];
      },

      enoughDetailsToAddADOrg() {
        return this.adOrg['Organization Name'] || this.adOrg['Organization Email Address'];
      },
    },

    mounted() {
      this.newSubmissionDetails = JSON.parse(JSON.stringify(this.submissionDetails));
      this.wwOrg = filemakerService.mapOrganizationSubmissionToFileMakerCreateOrganization(this.newSubmissionDetails.revisedWoodworker);
      this.wwContact = filemakerService.mapContactSubmissionToFileMakerCreateContact(this.newSubmissionDetails.revisedWoodworkerContact);
      this.gcOrg = filemakerService.mapOrganizationSubmissionToFileMakerCreateOrganization(this.newSubmissionDetails.revisedContractor);
      this.gcContact = filemakerService.mapContactSubmissionToFileMakerCreateContact(this.newSubmissionDetails.revisedContractorContact);
      this.adOrg = filemakerService.mapOrganizationSubmissionToFileMakerCreateOrganization(this.newSubmissionDetails.revisedFirm);
      this.adContact = filemakerService.mapContactSubmissionToFileMakerCreateContact(this.newSubmissionDetails.revisedFirmContact);
      this.project = projectRegistrationService.mapProjectSubmissionToFileMakerCreateProject(this.newSubmissionDetails.revisedProjectInfo);
    },

    methods: {
      async beginProcess() {
        this.submitting = true;
        // Woodworker Organization
        if (this.enoughDetailsToAddWWOrg) {
          if (!this.wwOrg['Organization ID']) {
            // Submit Woodworker Organization, if we didn't select it
            const { data: wwOrgResult } = await createOrg(this.wwOrg);
            this.submissionSteps[0].status = 'completed';
            if (wwOrgResult.messages[0].message !== 'OK') {
              this.submissionSteps[0].status = 'error';
              this.$toast.error('An error occurred while trying to create a woodworker organization');
              this.processingErrorMessage = wwOrgResult.messages[0].message;
              return;
            }
            const { data: wwOrgQueryResult } = await queryFirstOrg(filemakerService.mapFileMakerCreateOrganizationToSafeQuery(this.wwOrg));
            this.wwOrg['Organization ID'] = wwOrgQueryResult['Organization ID'];
          } else {
            // Update Woodworker Organization, if we selected it
            await updateOrg(this.wwOrg['Organization ID'], this.wwOrg);
            this.submissionSteps[0].status = 'completed';
          }
        }

        // Woodworker Contact
        if (this.enoughDetailsToAddWWContact) {
          if (!this.wwContact['Organization ID']) this.wwContact['Organization ID'] = this.wwOrg['Organization ID'];
          if (!this.wwContact['Contact ID']) {
            // Submit Woodworker Contact, if we didn't select it
            const { data: wwContactResult } = await createContact(this.wwContact);
            this.submissionSteps[1].status = 'completed';
            if (wwContactResult.messages[0].message !== 'OK') {
              this.submissionSteps[1].status = 'error';
              this.$toast.error('An error occurred while trying to create the woodworker contact');
              this.processingErrorMessage = wwContactResult.messages[0].message;
              return;
            }
            const { data: wwContactQueryResult } = await queryFirstContact({
              'Organization ID': this.wwContact['Organization ID'],
              Email: `*${this.wwContact.Email.substring(0, this.wwContact.Email.indexOf('@'))}*`,
            });
            this.wwContact['Contact ID'] = wwContactQueryResult['Contact ID'];
          } else {
            // Update Woodworker Contact, if we selected it
            await updateContact(this.wwContact['Contact ID'], this.wwContact);
            this.submissionSteps[1].status = 'completed';
          }
        }

        // General Contractor Organization
        if (this.enoughDetailsToAddGCOrg) {
          if (!this.gcOrg['Organization ID']) {
            // Submit General Contractor Organization, if we didn't select it
            const { data: gcOrgResult } = await createOrg(this.gcOrg);
            this.submissionSteps[2].status = 'completed';
            if (gcOrgResult.messages[0].message !== 'OK') {
              this.submissionSteps[2].status = 'error';
              this.$toast.error('An error occurred while trying to create a General Contractor organization');
              this.processingErrorMessage = gcOrgResult.messages[0].message;
              return;
            }
            const { data: gcOrgQueryResult } = await queryFirstOrg(this.gcOrg);
            this.gcOrg['Organization ID'] = gcOrgQueryResult['Organization ID'];
          } else {
            // Update General Contractor Organization, if we selected it
            await updateOrg(this.gcOrg['Organization ID'], this.gcOrg);
            this.submissionSteps[2].status = 'completed';
          }
        }

        // General Contractor Contact
        if (this.enoughDetailsToAddGCContact) {
          if (!this.gcContact['Organization ID']) this.gcContact['Organization ID'] = this.gcOrg['Organization ID'];
          if (!this.gcContact['Contact ID']) {
            // Submit General Contractor Contact, if we didn't select it
            const { data: gcContactResult } = await createContact(this.gcContact);
            this.submissionSteps[3].status = 'completed';
            if (gcContactResult.messages[0].message !== 'OK') {
              this.submissionSteps[3].status = 'error';
              this.$toast.error('An error occurred while trying to create the General Contractor contact');
              this.processingErrorMessage = gcContactResult.messages[0].message;
              return;
            }
            const { data: gcContactQueryResult } = await queryFirstContact({
              'Organization ID': this.gcContact['Organization ID'],
              Email: `*${this.gcContact.Email.substring(0, this.gcContact.Email.indexOf('@'))}*`,
            });

            this.gcContact['Contact ID'] = gcContactQueryResult['Contact ID'];
          } else {
            // Update General Contractor Contact, if we selected it
            await updateContact(this.gcContact['Contact ID'], this.gcContact);
            this.submissionSteps[3].status = 'completed';
          }
        }

        // Firm Organization
        if (this.enoughDetailsToAddADOrg) {
          if (!this.adOrg['Organization ID']) {
            // Submit Firm Organization, if we didn't select it
            const { data: adOrgResult } = await createOrg(this.adOrg);
            this.submissionSteps[4].status = 'completed';
            if (adOrgResult.messages[0].message !== 'OK') {
              this.submissionSteps[4].status = 'error';
              this.$toast.error('An error occurred while trying to create a Firm organization');
              this.processingErrorMessage = adOrgResult.messages[0].message;
              return;
            }
            const { data: adOrgQueryResult } = await queryFirstOrg(this.adOrg);
            this.adOrg['Organization ID'] = adOrgQueryResult['Organization ID'];
          } else {
            // Update Firm Organization, if we selected it
            await updateOrg(this.adOrg['Organization ID'], this.adOrg);
            this.submissionSteps[4].status = 'completed';
          }
        }

        // Firm Contact
        if (this.enoughDetailsToAddADContact) {
          if (!this.adContact['Organization ID']) this.adContact['Organization ID'] = this.adOrg['Organization ID'];
          if (!this.adContact['Contact ID']) {
            // Submit Firm Contact, if we didn't select it
            const { data: adContactResult } = await createContact(this.adContact);
            this.submissionSteps[5].status = 'completed';
            if (adContactResult.messages[0].message !== 'OK') {
              this.submissionSteps[5].status = 'error';
              this.$toast.error('An error occurred while trying to create the Firm contact');
              this.processingErrorMessage = adContactResult.messages[0].message;
              return;
            }
            const { data: adContactQueryResult } = await queryFirstContact({
              'Organization ID': this.adContact['Organization ID'],
              Email: `*${this.adContact.Email.substring(0, this.adContact.Email.indexOf('@'))}*`,
            });
            this.adContact['Contact ID'] = adContactQueryResult['Contact ID'];
          } else {
            // Update Firm Contact, if we selected it
            await updateContact(this.adContact['Contact ID'], this.adContact);
            this.submissionSteps[5].status = 'completed';
          }
        }

        // Project
        if (this.wwOrg['Organization ID']) this.project.WWID = this.wwOrg['Organization ID'];
        if (this.wwContact['Contact ID']) this.project['WW Contact ID'] = this.wwContact['Contact ID'];
        if (this.adOrg['Organization ID']) this.project.ARCompanyID = this.adOrg['Organization ID'];
        if (this.adContact['Contact ID']) this.project.ARContactID = this.adContact['Contact ID'];
        if (this.gcOrg['Organization ID']) this.project.GCCompanyID = this.gcOrg['Organization ID'];
        if (this.gcContact['Contact ID']) this.project.GCContactID = this.gcContact['Contact ID'];
        if (!this.project['QCP Project Number Calc']) {
          // Submit Project, if we didn't select it
          const { data: projectResult } = await createProject(this.project);
          this.project['QCP Project Number Calc'] = projectResult['QCP Project Number Calc'];
          this.submissionSteps[6].status = 'completed';
          if (projectResult.messages[0].message !== 'OK') {
            this.submissionSteps[6].status = 'error';
            this.$toast.error('An error occurred while trying to create the project');
            this.processingErrorMessage = projectResult.messages[0].message;
            return;
          }
        } else {
          // Update Project, if we selected it
          await updateProject(this.project['QCP Project Number Calc'], this.project);
          this.submissionSteps[6].status = 'completed';
        }

        // Update the info in the local DB
        this.newSubmissionDetails.status = RequestStatus.Completed;
        await updateAdmin(this.submissionId, this.newSubmissionDetails);
        this.$parent.events.updateRevisedInfo(this.newSubmissionDetails);
        await sendApprovedEmail(this.submissionId, this.project['QCP Project Number Calc']);

        // Wrap up
        this.$parent.close();
        this.$toast.success('The application has finished processing and marked as completed');
      },
    },
  };
</script>